import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';
import { LIST } from '../../../constants/constant_doc_types';

class CustomFieldDropdown extends Component {
  render() {
    const {
      form,
      multiple,
      name,
      onPostChange,
      searchFn,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          dropdownType={LIST}
          formId={form}
          name={name}
          onPostChange={onPostChange}
          preload={preload}
          searchFn={searchFn}
          type={LIST}
          valueField="id"
        />
      </div>
    );
  }
}

export default connect(
  null,
  { searchFn: fetchDropdown },
)(CustomFieldDropdown);
